import { LoginCallback as OktaLoginCb } from '@okta/okta-react';
import React, { FC } from 'react';
import AccessDenied from './AccessDenied';

export const GROWLoginCallback: FC = () => (
  <OktaLoginCb errorComponent={() => <AccessDenied />} />
);
